import React from "react";
import { FileText, Image as ImageIcon, Link as LinkIcon, FileBadge } from "lucide-react";
const badgeClasses = {
  "सादर झाले": "bg-sky-100 text-sky-700",
  "पडताळणी सुरू": "bg-amber-100 text-amber-700",
  "पडताळणी पूर्ण": "bg-emerald-100 text-emerald-700",
  मंजूर: "bg-green-100 text-green-700",
  नामंजूर: "bg-red-100 text-red-700",
  प्रलंबित: "bg-slate-200 text-slate-600",
};
export function Badge({ status }) {
  return (
    <span
      className={`px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap ${badgeClasses[status] || "bg-slate-200 text-slate-600"}`}
    >
      {status}
    </span>
  );
}
export function evIcon(type) {
  if (type === "image") return <ImageIcon size={22} />;
  if (type === "pdf") return <FileText size={22} />;
  if (type === "certificate") return <FileBadge size={22} />;
  return <LinkIcon size={18} />;
}
export function evLabel(type) {
  return (
    { image: "Image", pdf: "PDF", certificate: "Certificate", link: "Link" }[
      type
    ] || type
  );
}
